import Request from './request'

export default class TrafficViolationsServices {
  static async CustomerCriminalRecordUserUserCheckCriminalFromVr(data = {}, token = undefined) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: 'POST',
        path: '/PartnerAPI/CustomerCriminalRecord/user/userCheckViolation',
        data,
        token
      }).then((result = {}) => {
        if (result?.statusCode === 200) {
          return resolve(result)
        }
        return reject(result)
      })
    })
  }

  static async CustomerCriminalRecordUserGetCrimeRecords(data = {}, token = undefined) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: 'POST',
        path: '/PartnerAPI/CustomerCriminalRecord/user/getCrimeRecords',
        data,
        token
      }).then((result = {}) => {
        if (result?.statusCode === 200) {
          return resolve(result)
        }
        return reject(result)
      })
    })
  }
}
